import { jsx as _jsx } from "react/jsx-runtime";
import { Dot } from "./styled";
const ExtensionStatusDot = ({ status }) => _jsx(Dot, { "$status": status });
export default ExtensionStatusDot;
